import EsgWeeklyEmail from './EsgWeeklyEmail'

export default EsgWeeklyEmail
